import { Material } from 'excalibur';
import { ShaderFactory } from './shader-factory';

export interface IShader {
  create(): Material;
}

export abstract class BaseShader implements IShader {
  protected factory: ShaderFactory;

  constructor() {
    this.factory = ShaderFactory.getInstance();
  }

  abstract create(): Material;
}
